import axios from 'axios'
export default{
    getTechClassList(){
     return axios.get("/api/techclass/");
    }
 }